import NavBar from '@/components/NavBar'
import Page from '@/components/Page'
import TopicSubscriptionToggleButton from '@/components/TopicSubscriptionToggleButton'
import { getTopicDetailQueryOptions } from '@/utils/fetchers/topic'
import useUniversalNavigate from '@/utils/hooks/useUniversalNavigate'
import { Tabs } from '@mantine/core'
import { useSuspenseQuery } from '@tanstack/react-query'
import { useTitle } from 'react-use'
import TopicHybridPage from './TopicHybridPage'
import TopicPostPage from './TopicPostPage'
import styles from './TopicPage.module.css'

export default function TopicPage({
	id,
	tab,
	hybridTopicId,
}: {
	id: string
	tab: string
	hybridTopicId?: string | null
}) {
	const isHybridTab = tab === 'hybrid'

	const { data: topic } = useSuspenseQuery(getTopicDetailQueryOptions(id))
	const navigate = useUniversalNavigate()

	useTitle(`${topic.content} - 即刻`)
	return (
		<Page header={<NavBar title="圈子详情" />}>
			<div className={styles.header}>
				<img width={120} height={120} src={topic.squarePicture.picUrl} className={styles.image} />
				<div className={styles.content}>
					<div className={styles.textGroup}>
						<div className={styles.title}>{topic.content}</div>
						<div className={styles.subtitle}>{topic.subscribersDescription}</div>
					</div>
					<TopicSubscriptionToggleButton id={id} />
				</div>
			</div>
			<Tabs
				classNames={{
					list: styles.tabsList,
					tab: styles.tab,
				}}
				onChange={(value) => {
					if (!value) {
						return
					}
					navigate({
						to: '/topic/$id/$tab',
						params: {
							id,
							tab: value,
						},
					})
				}}
				value={tab}
			>
				<Tabs.List grow>
					{topic.tabs.map((item) => (
						<Tabs.Tab key={item.type} value={item.type} fw={500} fz={18} lh={1.5}>
							{item.name}
						</Tabs.Tab>
					))}
				</Tabs.List>
			</Tabs>
			{isHybridTab ? (
				hybridTopicId && <TopicHybridPage topicId={hybridTopicId} />
			) : (
				<TopicPostPage id={id} tab={tab} />
			)}
		</Page>
	)
}
